type data = {
    email: string,
    medium_handle: string,
    url: string,
    notes?: string
}

  export default async function postData(data : data) {
        const endpoint ='https://submit-post.herokuapp.com/submitpost';
        const response = await fetch(endpoint, {
          method: 'POST',
          mode: 'cors',
          credentials: 'omit',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(data) 
        });
        return response.json();
      }
      
 







